/**
 * Aba Inicio: o painel do dia. Cada modulo poe o seu bloco (Reabordar hoje,
 * Fichas a conferir, Tarefas de hoje) por `blocosDoInicio`, sem o shell citar
 * modulo por nome. Um modulo ainda pode reclamar a rota `/` inteira
 * declarando `rota: '/'` na tela dele.
 */
import { useIdioma } from '../i18n/index.tsx';
import { EstadoVazio, PaginaSecao } from '../layout/Shell.tsx';
import { useSessao } from '../sessao.tsx';
import { TelaDeModuloMontada } from '../modules/montar.tsx';
import { TELAS, blocosDoInicio } from '../modules/registro.ts';

const TELA_INICIO = TELAS.find((t) => t.rota === '/');

/**
 * Os blocos que os modulos poem no topo do Inicio (os cards do modulo
 * Inicio), so os de modulo instalado e com permissao.
 */
function useBlocos() {
  const { estado } = useSessao();
  const eu = estado.fase === 'dentro' ? estado.eu : null;
  return blocosDoInicio().filter((b) => eu !== null && eu.modulos.includes(b.modulo)
    && (b.permissao === undefined || eu.permissoes.includes(b.permissao)));
}

function Blocos() {
  const blocos = useBlocos();
  if (blocos.length === 0) return null;
  return (
    <div className="inicio__blocos">
      {blocos.map((b) => <b.conteudo key={`${b.modulo}.${b.id}`} />)}
    </div>
  );
}

export function PaginaInicial() {
  const { estado } = useSessao();
  const eu = estado.fase === 'dentro' ? estado.eu : null;
  const usavel = TELA_INICIO !== undefined && eu !== null
    && eu.modulos.includes(TELA_INICIO.slug)
    && eu.permissoes.includes(`${TELA_INICIO.slug}.ver`);
  return usavel ? <TelaDeModuloMontada tela={TELA_INICIO} topo={<Blocos />} /> : <Inicio />;
}

export function Inicio() {
  const { t } = useIdioma();
  const blocos = useBlocos();
  return (
    <PaginaSecao kicker={t('inicio.kicker')} titulo={t('inicio.titulo')}>
      <Blocos />
      {blocos.length === 0
        && <EstadoVazio titulo={t('estado.vazio.titulo')} texto={t('inicio.texto')} />}
    </PaginaSecao>
  );
}
